<script lang="ts">
  export interface ToastItem {
    id: string;
    message: string;
    type: 'info' | 'success' | 'warning' | 'error';
  }

  interface Props {
    toasts: ToastItem[];
  }

  let { toasts }: Props = $props();
</script>

{#if toasts.length > 0}
  <div class="toast toast-end toast-bottom z-[9999] gap-2">
    {#each toasts as toast (toast.id)}
      <div class="alert shadow-2xl border border-base-300 min-w-[280px] {
        toast.type === 'success' ? 'alert-success text-white' :
        toast.type === 'error' ? 'alert-error text-white' :
        toast.type === 'warning' ? 'alert-warning text-black' :
        'alert-info text-white'
      }">
        <span class="font-semibold text-sm">{toast.message}</span>
      </div>
    {/each}
  </div>
{/if}
